import * as React from 'react';

import buildingLayer from '@assets/map-style/building-layer';
import darkMapStyle from '@assets/map-style/dark-map-style';
import focusDataLayer from '@assets/map-style/focus-data-layer';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';

import { useRouter } from 'next/router';
import { Layer as ReactMapGlLayer, StaticMap } from 'react-map-gl';

type IProps = {
  zoom?: number;
  height?: React.ReactText;
  width?: React.ReactText;
  isPanning?: boolean;
  lieuucationId: string;
  centLat: number;
  centLon: number;
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(2)
    },
    marker: {
      color: theme.palette.secondary.light
    }
  });

export const LieuucationMap: React.FC<WithStyles<typeof styles> & IProps> = ({
  zoom,
  height,
  width,
  lieuucationId,
  centLat,
  centLon
}) => {
  const { query } = useRouter();

  return (
    <StaticMap
      latitude={Number(query.lat) || centLat}
      longitude={Number(query.lon) || centLon}
      zoom={Number(query.zoom) - 2.5 || zoom || 12}
      pitch={60}
      width={width || '100%'}
      height={height || 300}
      mapboxApiAccessToken={process.env.MAPBOX_PUBLIC_ACCESS_TOKEN}
      mapStyle={darkMapStyle}
    >
      <ReactMapGlLayer
        {...focusDataLayer}
        filter={['in', 'internalId', lieuucationId]}
      />
      <ReactMapGlLayer {...buildingLayer} />
    </StaticMap>
  );
};

export default withStyles(styles)(LieuucationMap);
